<div class="modal fade" id="kt_modal_faq_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update FAQ' : 'Add FAQ' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="faqForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Question -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Question</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="question"
                placeholder="Enter FAQ question"
                [class.is-invalid]="question?.invalid && question?.touched"
              />
              <div *ngIf="question?.invalid && question?.touched" class="invalid-feedback">
                <div *ngIf="question?.errors?.['required']">Question is required</div>
                <div *ngIf="question?.errors?.['minlength']">Question must be at least 5 characters</div>
              </div>
            </div>

            <!-- Answer -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Answer</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="answer"
                placeholder="Enter FAQ answer"
                rows="5"
                [class.is-invalid]="answer?.invalid && answer?.touched"
              ></textarea>
              <div *ngIf="answer?.invalid && answer?.touched" class="invalid-feedback">
                <div *ngIf="answer?.errors?.['required']">Answer is required</div>
                <div *ngIf="answer?.errors?.['minlength']">Answer must be at least 10 characters</div>
              </div>
            </div>

            <!-- Image Upload -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Image</label>
              <div class="image-input image-input-outline" data-kt-image-input="true">
                <!-- Image Preview -->
                <div
                  class="faq-image-preview image-input-wrapper w-125px h-125px"
                  [style.background-image]="imagePreviewUrl ? 'url(' + imagePreviewUrl + ')' : 'none'"
                  [style.background-color]="!imagePreviewUrl ? '#f5f8fa' : 'transparent'"
                  [style.background-size]="'cover'"
                  [style.background-position]="'center'">
                </div>

                <!-- Upload Button -->
                <label
                  class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                  data-kt-image-input-action="change"
                  data-bs-toggle="tooltip"
                  title="Change image">
                  <i class="ki-duotone ki-pencil fs-7">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  <input
                    type="file"
                    name="image_url"
                    accept=".png, .jpg, .jpeg"
                    (change)="onImageSelected($event)" />
                  <input type="hidden" formControlName="image_url" />
                </label>

                <!-- Remove Button -->
                <span
                  *ngIf="imagePreviewUrl"
                  class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                  data-kt-image-input-action="remove"
                  data-bs-toggle="tooltip"
                  title="Remove image"
                  (click)="removeImage()">
                  <i class="ki-duotone ki-cross fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
              </div>
              <div class="form-text">Allowed file types: png, jpg, jpeg. Max size: 5MB</div>
              <div *ngIf="isImageUploading" class="mt-2">
                <span class="spinner-border spinner-border-sm me-2"></span>
                <span class="text-muted">Uploading image...</span>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading || isImageUploading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
